module.exports = __webpack_public_path__ + "static/media/project_img_003.833a64dc.jpg";